import logo from '../assets/images/icon-logo@3x.png';

import filterEmptyField from './methods/filterEmptyField';

const loadHref = window.location.href;
let vue;
const config = {
  created() {
    if (!vue) {
      // console.warn('[vue-msg] not installed!');
    }
  },
  mounted() {},
  data() {
    return {
      logo: `${logo}`.replace(/^\/\//, `${window.location.protocol}//`),
    };
  },
  methods: {
    loadScript(srcs = []) {
      return srcs.map((src) => {
        return new Promise((resolve, reject) => {
          const $script = document.createElement('script');
          $script.src = src;
          $script.onload = resolve;
          $script.onerror = reject;
          document.body.appendChild($script);
        });
      });
    },
    /**
     * 添加统计代码
     */
    addCounter() {
      const $counter = document.querySelector('.counter');
      const $script = document.createElement('script');
      window._hmt = window._hmt || [];
      $script.src = `https://hm.baidu.com/hm.js?c923d5797c996eb1c128aadb8217bfab&t=${new Date().getTime()}`;
      // $script.src = `https://hm.baidu.com/hm.js?69484acc66ac8a28773a02e108dbfb8a&t=${new Date().getTime()}`;
      $counter.innerHTML = '';
      document.querySelector('.counter').appendChild($script);
    },
    // 缩略图
    getImageResize(outSrc, outWidth = 80, outHeight) {
      if (!outSrc) return '';
      const src = typeof outSrc === 'string' ? [outSrc] : outSrc || [];
      const srcs = src.map((itemSrc) => {
        console.log(itemSrc);
        if (!/^http/.test(itemSrc)) return itemSrc;
        const size = outHeight ? `w_${outWidth},h_${outHeight}` : `w_${outWidth}`;
        return `${itemSrc.split('?')[0]}?x-oss-process=image/resize,m_lfit,${size}&t=${new Date().getTime()}`;
      });
      return typeof outSrc === 'string' ? srcs[0] : srcs;
    },
  },
  computed: {
    safeAreaInsetTopStyle() {
      const isApp = (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
      const isAndroid = (navigator.userAgent.match(/android/i) && true) || false;
      if (!isApp || !isAndroid) return {};
      const statusBarHeight = window.cfmoto.statusBarHeight();
      return { paddingTop: statusBarHeight };
    },
    safeAreaInsetBottomStyle() {
      const isApp = (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
      const isAndroid = (navigator.userAgent.match(/android/i) && true) || false;
      if (!isApp || !isAndroid) return {};
      const statusBarHeight = window.cfmoto.statusBarHeight();
      return { paddingBottom: statusBarHeight };
    },
    safeAreaInsetBottom() {},
    isFoldableScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 < 1.4;
    },
    isSmallScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 < 2;
    },
    isLargeScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 > 2.167;
    },
    isPlusLargeScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 > 2.3;
    },
    isAndroid() {
      return (navigator.userAgent.toLowerCase().match(/android/i) && true) || false;
    },
    isApple() {
      return (navigator.userAgent.toLowerCase().match(/(iPhone|iPod|iPad);?/i) && true) || false;
    },
    isHarmonyNext() {
      const ua1 = (navigator.userAgent.toLowerCase().match(/openharmony/i) && true) || false;
      const ua2 = (navigator.userAgent.toLowerCase().match(/arkweb/i) && true) || false;
      return ua1 || ua2;
    },
    isWechat() {
      return (navigator.userAgent.toLowerCase().match(/micromessenger/i) && true) || false;
    },
    isMiniapp() {
      return (navigator.userAgent.toLowerCase().match(/miniprogram/i) && true) || false;
    },
    isQQ() {
      return (navigator.userAgent.toLowerCase().match(/qq/i) && true) || false;
    },
    isWeibo() {
      return (navigator.userAgent.toLowerCase().match(/weibo/i) && true) || false;
    },
    isApp() {
      return (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
    },
    // 模拟
    // isApp() {
    //   return true;
    // },
    isMobile() {
      return (navigator.userAgent.toLowerCase().match(/mobile/i) && true) || false;
    },
    isWeb() {
      return !(this.isWechat || this.isWeibo || this.isApp);
    },
    device() {
      const { width, height } = window.screen;
      const screenAspect = [{ width: 375, height: 812, device: 'iPhoneX' }];
      const isSameScreenAspectRatio = (deviceWidth, deviceHeight, targetWidth, targetHeight) => (deviceHeight / deviceWidth) * targetWidth === targetHeight;
      for (let i = 0; i < screenAspect.length; i++) {
        if (isSameScreenAspectRatio(width, height, screenAspect[i].width, screenAspect[i].height)) {
          return screenAspect[i].device;
        }
      }
      return 'unknown';
    },
    // ios环境微信签名url
    iosHref() {
      return loadHref;
    },
    isInDingTalk() {
      var userAgent = navigator.userAgent;
      return userAgent.indexOf('DingTalk') !== -1 || userAgent.indexOf('DingTalkBot') !== -1;
    },
  },
  watch: {},
};
export default {
  mixin: [config],
  install(Vue) {
    vue = Vue;
    vue.addCounter = config.methods.addCounter;
    vue.isLargeScreen = config.computed.isLargeScreen();
    vue.isPlusLargeScreen = config.computed.isPlusLargeScreen();
    vue.isAndroid = config.computed.isAndroid();
    vue.isApple = config.computed.isApple();
    vue.isInDingTalk = config.computed.isInDingTalk();
    vue.isHarmonyNext = config.computed.isHarmonyNext();
    vue.isWechat = config.computed.isWechat();
    vue.isMiniapp = config.computed.isMiniapp();
    vue.isQQ = config.computed.isQQ();
    vue.isWeibo = config.computed.isWeibo();
    vue.isApp = config.computed.isApp();
    vue.isWeb = config.computed.isWeb();
    vue.device = config.computed.device();
    vue.iosHref = config.computed.iosHref();
    vue.mixin(config);
    vue.mixin(filterEmptyField);
  },
};
